import { Box, Checkbox, FormControlLabel, Radio, RadioGroup } from "@mui/material";

type Props = {
  label: string;
  separateInvoice: boolean;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  invoicePerService: boolean;
  setFieldValue: (field: string, value: boolean) => void;
  separateInvoiceFieldName: string;
  invoicePerServiceFieldName: string;
};

export const MarketplaceSettings = ({
  label,
  separateInvoice,
  handleChange,
  invoicePerService,
  setFieldValue,
  separateInvoiceFieldName,
  invoicePerServiceFieldName,
}: Props) => (
  <Box>
    <FormControlLabel
      control={
        <Checkbox
          checked={separateInvoice}
          name={separateInvoiceFieldName}
          onChange={handleChange}
          data-cy={`marketplace-settings-separate-${label.toLowerCase()}-checkbox`}
        />
      }
      label={`Separate ${label} Marketplace purchases`}
    />
    <Box sx={{ display: "flex", flexDirection: "column", ml: 3 }}>
      <RadioGroup
        name={invoicePerServiceFieldName}
        value={invoicePerService}
        onChange={(e) => {
          setFieldValue(invoicePerServiceFieldName, e.target.value === "true");
        }}
      >
        <FormControlLabel
          label="Create individual invoices for each purchase"
          control={<Radio data-cy={`marketplace-settings-individual-${label.toLowerCase()}-radio`} />}
          value={true}
          disabled={!separateInvoice}
        />
        <FormControlLabel
          label="Create a single invoice with line items for each purchase"
          control={<Radio data-cy={`marketplace-settings-single-${label.toLowerCase()}-radio`} />}
          value={false}
          disabled={!separateInvoice}
        />
      </RadioGroup>
    </Box>
  </Box>
);
